import React from 'react';
import styles from './BackButton.module.css';

interface BackButtonProps {
  onClick: () => void;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick }) => {
  return (
    <button className={styles.backButton} onClick={onClick}>
      <svg width="16" height="16" viewBox="4 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.75 8L9.795 12L10.25 10.31L7.905 8L10.25 5.69L9.795 4L5.75 8Z" fill="#0D8426" />
      </svg>
      <span>Back to start</span>
    </button>
  );
};

export default BackButton;
